import { useState } from 'react';

const reviews = [
  {
    quote: 'Rafael and his team completely transformed our outdated kitchen into a stunning modern space. From the initial consultation to the final walkthrough, they were professional, on-time, and genuinely cared about getting every detail right. We couldn\'t be happier with the result!',
    author: 'Maria S.',
    location: 'Sterling, VA',
    project: 'Kitchen Remodeling',
    rating: 5,
  },
  {
    quote: 'We hired Rafael M&C for a complete master bathroom renovation, and the experience was exceptional. They helped us choose the perfect materials, stayed within our budget, and the craftsmanship is outstanding. Our bathroom now feels like a luxury spa. Highly recommend!',
    author: 'James T.',
    location: 'Reston, VA',
    project: 'Bathroom Remodeling',
    rating: 5,
  },
  {
    quote: "As a property manager, finding reliable contractors is tough. Rafael M&C has been handling our plumbing and renovation needs for two years now. Consistent quality, fair pricing, and always responsive. They're my go-to for all our properties.",
    author: 'David L.',
    location: 'Washington, D.C.',
    project: 'Plumbing & General Contracting',
    rating: 5,
  },
  {
    quote: 'The team at Rafael M&C did an amazing job on our basement finishing project. What impressed me most was their communication — I always knew what was happening, when they\'d be there, and what to expect next. The finished space exceeded our expectations.',
    author: 'Sarah &amp; Michael K.',
    location: 'Ashburn, VA',
    project: 'General Contracting',
    rating: 5,
  },
];

export default function CustomerReviews() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? reviews.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === reviews.length - 1 ? 0 : c + 1));

  const review = reviews[current];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100 relative overflow-hidden">
      <div className="relative max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-center">
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '3/4' }}>
              <img
                src="/images/reviews/reviews.webp"
                alt="Happy clients"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="inline-block text-xs md:text-sm font-medium tracking-wider uppercase text-accent-600 mb-3">
              Testimonials
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-8">
              What Our{' '}
              <span className="text-primary-500">Clients Say</span>
              <br />
              <span className="text-foreground-400">About Our Work</span>
            </h2>

            <div className="mb-6">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-400"></i>
                  </div>
                ))}
              </div>
              <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed italic mb-6">
                &ldquo;{review.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">— {review.author}</p>
                  <p className="text-xs text-foreground-500">{review.location} &bull; {review.project}</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:border-primary-400 hover:text-primary-500 transition-all cursor-pointer"
                aria-label="Previous review"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
                aria-label="Next review"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <div className="flex items-center gap-1.5 ml-3">
                {reviews.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      i === current ? 'bg-primary-500 w-5' : 'bg-foreground-300'
                    }`}
                    aria-label={`Go to review ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}